
(function(){
  var fine = matchMedia('(pointer:fine)').matches;
  var noMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* reading progress */
  if (!noMotion) {
    var bar = document.createElement('div'); bar.id = 'vus-progress';
    document.body.appendChild(bar);
    var ticking = false;
    addEventListener('scroll', function(){
      if (ticking) return; ticking = true;
      requestAnimationFrame(function(){
        var h = document.documentElement;
        var max = h.scrollHeight - innerHeight;
        bar.style.width = (max > 0 ? (h.scrollTop / max) * 100 : 0) + '%';
        ticking = false;
      });
    }, {passive:true});
  }

  /* claret cursor companion */
  if (fine && !noMotion) {
    var dot = document.createElement('div'); dot.id = 'vus-cursor';
    document.body.appendChild(dot);
    var x=0,y=0,cx=0,cy=0,seen=false;
    addEventListener('mousemove', function(e){
      x=e.clientX; y=e.clientY;
      if(!seen){ seen=true; document.body.classList.add('vus-cursor-on'); cx=x; cy=y; loop(); }
      var t = e.target.closest && e.target.closest('a,button,[role=button],input,label,summary');
      dot.classList.toggle('grow', !!t);
    }, {passive:true});
    function loop(){
      cx += (x-cx)*.22; cy += (y-cy)*.22;
      dot.style.transform = 'translate(' + (cx-4) + 'px,' + (cy-4) + 'px)';
      requestAnimationFrame(loop);
    }
  }

  /* footer live NYC time */
  try {
    var els = document.querySelectorAll('footer p, footer span, footer div');
    var target = null;
    els.forEach(function(el){
      if (!target && el.children.length === 0 && /NEW YORK CITY\s*—\s*ISSUE/i.test(el.textContent)) target = el;
    });
    if (target) {
      var tick = function(){
        var t = new Intl.DateTimeFormat('en-US', {timeZone:'America/New_York', hour:'2-digit', minute:'2-digit', hour12:false}).format(new Date());
        target.textContent = 'NEW YORK CITY ' + t + ' — ISSUE No. 001';
      };
      tick(); setInterval(tick, 30000);
    }
  } catch(e){}
})();

/* per-color gallery filter (dual-colorway PDPs) */
(function(){
  var RULES = {
    'gathered-side-slit-midi-dress': { 'Sage': 'cagla', 'Sky Blue': 'acikmavi' }
  };
  var handle = (location.pathname.match(/\/products\/([a-z0-9-]+)/) || [])[1];
  var MAP = RULES[handle];
  if (!MAP) return;
  var tokens = Object.values(MAP);
  function apply(){
    var token = null;
    for (var name in MAP){
      var inp = document.querySelector('input[type="radio"][value="' + name + '"]:checked, input[type="radio"][value="' + name.toLowerCase() + '"]:checked');
      if (inp) token = MAP[name];
    }
    if (!token) return;
    document.querySelectorAll('img').forEach(function(img){
      var src = img.currentSrc || img.src || '';
      var mine = src.indexOf(token) !== -1;
      var other = !mine && tokens.some(function(t){ return src.indexOf(t) !== -1; });
      if (!mine && !other) return;                 /* unrelated image */
      var slide = img.closest('slideshow-slide, .product-media-container, li, figure') || img;
      /* only touch slides inside the product gallery, not cart/recs */
      if (!slide.closest('media-gallery, .product-media-gallery, [class*="media-gallery"], slideshow-component')) return;
      slide.style.display = other ? 'none' : '';
      if (other) slide.setAttribute('aria-hidden','true'); else slide.removeAttribute('aria-hidden');
    });
  }
  document.addEventListener('change', function(){ setTimeout(apply, 120); setTimeout(apply, 600); });
  addEventListener('load', function(){ apply(); setTimeout(apply, 800); });
  new MutationObserver(function(){ apply(); }).observe(document.body, {childList:true, subtree:true});
})();
